import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import LastOrders from "./LastOrders";
import Profile from "../Profile";

const Counter = () => {
    return (
        <div className="counter-wrapper">
            <Profile/>
            <div className="container container-counter">
                <div className="personal-information xmb-8 xmb-lg-12">
                    <div className="title xmb-2">
                        <div className="title-box just-text title-box-blue">
                            <div className="title-bg">
                                <h2 className="text">
                                    اطلاعات شخصی
                                </h2>
                            </div>
                            <div className="more" id="edit-personal-information">
                                <span className="icon-edit"><IconName name="create" className="icon"/></span>
                                <span className="text">ویرایش</span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="input-box">
                                <input type="text" className="input-information xmt-4 xmt-lg-6"
                                       value="علی صادقی" disabled="true"/>
                                <div className="default-value position-absolute">نام و نام خانوادگی</div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="input-box">
                                <input type="number" className="input-information xmt-4 xmt-lg-6"
                                       value="09904456324" disabled="true"/>
                                <div className="default-value position-absolute">شماره موبایل</div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="input-box">
                                <input type="email" className="input-information xmt-4 xmt-lg-6"
                                       value="alisadeghi@gmail.com"
                                       placeholder="" disabled="true"/>
                                <div
                                    className="default-value position-absolute">آدرس ایمیل
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="input-box">
                                <input type="password" className="input-information xmt-4 xmt-lg-6"
                                       value="3610315441" disabled="true"/>
                                <div
                                    className="default-value position-absolute">رمز عبور
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="input-box">
                                <input type="text" className="input-information xmt-4 xmt-lg-6"
                                       disabled="true" value="۱۳۸۲۱۳۹۳۹۱‌"/>
                                <div
                                    className="default-value position-absolute">
                                    کد ملی
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="input-box">
                                <input type="text" className="input-information xmt-4 xmt-lg-6" placeholder=""
                                       disabled="true" value="****-****-****-۲۵۲۷‌"/>
                                <div
                                    className="default-value position-absolute">
                                    شماره کارت
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LastOrders/>
            </div>
        </div>
    );
};

export default Counter;
